import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/denied/usage.deniedUser.query.gql"
import type {
  UsageLicenseDeniedUserQuery,
  UsageLicenseDeniedUserQueryVariables,
} from "@/v2-backoffice-client/usage/denied/__types__/usage.deniedUser.query"

type Options = QueryHookOptions<
  UsageLicenseDeniedUserQuery,
  UsageLicenseDeniedUserQueryVariables
>

export function useUsageLicenseDeniedUserQuery(options?: Options) {
  return useQuery<
    UsageLicenseDeniedUserQuery,
    UsageLicenseDeniedUserQueryVariables
  >(query, options)
}
